module.exports = "/assets/data/32bdada2c101d3fb83c0994b88dca0c9-CM9.data.json";